var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuIdos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 0.5C9.33165 0.5 9.6 0.76835 9.6 1.1V4.1C9.6 4.43165 9.33165 4.7 9 4.7C8.66835 4.7 8.4 4.43165 8.4 4.1V1.72228C4.37812 2.03045 1.2 5.4008 1.2 9.5C1.2 13.8008 4.6992 17.3 9 17.3C13.3008 17.3 16.8 13.8008 16.8 9.5C16.8 7.66835 16.152 5.8871 14.9754 4.48554C14.7621 4.23241 14.7949 3.85393 15.0492 3.64063C15.3035 3.42733 15.6809 3.46018 15.8942 3.71446C17.2523 5.33165 18 7.38594 18 9.5C18 14.4629 13.9629 18.5 9 18.5C4.0371 18.5 0 14.4629 0 9.5C0 4.5371 4.0371 0.5 9 0.5ZM9.4242 9.9242C9.30705 10.0414 9.15352 10.1 9 10.1C8.84647 10.1 8.69295 10.0414 8.5758 9.9242C8.34142 9.68983 8.34142 9.31014 8.5758 9.0758L11.5758 6.0758C11.8102 5.84143 12.1899 5.84143 12.4242 6.0758C12.6585 6.31018 12.6586 6.68986 12.4242 6.9242L9.4242 9.9242Z",
    fill: "#97D4C6"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIdos);
export default __webpack_public_path__ + "static/media/menu-idos.4f59375bad47f5648bd6b2dd5bd4309b.svg";
export { ForwardRef as ReactComponent };